export default function Container({
                                      children,
                                      size = "max-w-7xl",
                                      padding = "p-6",
                                      visible = true,
                                      transparent = false,
                                      color = "bg-white",
                                      shadow = true,
                                      outerPadding = 'py-12',
                                      wrapperClassName = "",
                                      className = "",
                                      ...props
                                  }) {
    return (
        <div
            {...props}
            className={`${outerPadding} ${size} ${wrapperClassName} mx-auto ${
                visible ? "" : "hidden"
            }`}
        >
            <div
                className={`${
                    transparent ? "" : `${color} sm:rounded-3xl`
                } overflow-hidden ${
                    shadow ? "shadow-sm" : ""
                }`}
            >
                <div className={`${padding} text-gray-900 ${className}`}>
                    {children}
                </div>
            </div>
        </div>
    );
}
